webpackJsonp([63],{

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_store__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
      linkActiveClass: 'active',
      routes: [{
            path: '/login',
            name: '登录',
            component: function component(resolve) {
                  return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(129)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
      }, {
            path: '/seeding_wall',
            name: '播种墙',
            component: {
                  template: "<p>Seeding wall</p>"
            }
      }, {
            path: '/',
            name: "主页",
            component: function component(resolve) {
                  return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(130)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            },
            redirect: '/index',
            children: [{
                  path: '/index',
                  name: '首页',
                  component: function component(resolve) {
                        return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(118)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                  }
            }, {
                  path: '/baseinfo',
                  name: '基本信息',
                  component: function component(resolve) {
                        return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(96)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                  },
                  redirect: '/baseinfo/customer_manage',
                  children: [{
                        path: "/baseinfo/customer_manage",
                        name: "客户管理",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(97)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/baseinfo/customer_manage/add",
                        name: "新增客户",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(31)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/baseinfo/customer_manage/edite/:customerid",
                        name: "编辑客户",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(4/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(31)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/baseinfo/goods_category_manage",
                        name: "商品品类管理",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(100)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/baseinfo/goods_classify_manage",
                        name: "商品分类管理（一级分类）",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(101)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/baseinfo/goods_classify_manage/sub1/:id",
                        name: "商品分类管理（二级分类）",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(102)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/baseinfo/goods_classify_manage/sub2/:id",
                        name: "商品分类管理（三级级分类）",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(98)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/baseinfo/goods_manage",
                        name: "商品管理",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(99)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/baseinfo/goods_manage/add",
                        name: "新增商品",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(32)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/baseinfo/goods_manage/edite/:productNo",
                        name: "编辑商品",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(32)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/baseinfo/goods_manage/detail/:productNo",
                        name: "商品详情",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(103)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/baseinfo/location_manage",
                        name: "库区管理",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(105)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/baseinfo/location_manage/addArea",
                        name: "新增库区",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(33)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/baseinfo/location_manage/editeArea/:areaId",
                        name: "编辑库区",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(3/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(33)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/baseinfo/location_manage/location/:areaId/:areaNo/:areaName/:areaType",
                        name: "管理库位",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(104)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }]
            }, {
                  path: '/instorage_action',
                  name: '入库作业',
                  component: function component(resolve) {
                        return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(119)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                  },
                  redirect: '/instorage_action/procurement_storage',
                  children: [{
                        path: "/instorage_action/procurement_storage",
                        name: "采购入库交接",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(122)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/instorage_action/procurement_storage/detail/:id",
                        name: "采购入库单详情",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(120)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/instorage_action/procurement_storage/purchase_order_add",
                        name: "新建采购单",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(34)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/instorage_action/procurement_storage/purchase_order_edite/:id",
                        name: "编辑采购单",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(34)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/instorage_action/procurement_storage/hand/:id",
                        name: "手工交接",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(121)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/instorage_action/sales_returns_warehousing",
                        name: "销售退货入库交接",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(125)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/instorage_action/sales_returns_warehousing/detail/:id",
                        name: "销售退货单详情",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(123)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/instorage_action/sales_returns_warehousing/hand/:id",
                        name: "销售手工交接",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(124)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/instorage_action/warehouse_shelves",
                        name: "入库上架",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(128)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/instorage_action/warehouse_shelves/detail/:id",
                        name: "入库单详情",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(126)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/instorage_action/warehouse_shelves/hand/:id",
                        name: "手工上架",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(127)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }]
            }, {
                  path: '/outstorage_action',
                  name: '出库作业',
                  component: function component(resolve) {
                        return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(131)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                  },
                  redirect: '/outstorage_action/sell_out',
                  children: [{
                        path: "/outstorage_action/sell_out",
                        name: '销售出库',
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(135)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/outstorage_action/sell_out/detail/:id",
                        name: '销售出库单详情',
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(134)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/outstorage_action/wave_picking",
                        name: '波次拣货',
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(141)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/outstorage_action/wave_picking/detail/:id",
                        name: '波次详情',
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(136)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        },
                        redirect: '/outstorage_action/wave_picking/detail/:id/order',
                        children: [{
                              path: '/outstorage_action/wave_picking/detail/:id/order',
                              name: '订单',
                              component: function component(resolve) {
                                    return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(138)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                              }
                        }, {
                              path: '/outstorage_action/wave_picking/detail/:id/goods',
                              name: '商品',
                              component: function component(resolve) {
                                    return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(137)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                              }
                        }]
                  }, {
                        path: "/outstorage_action/wave_picking/add",
                        name: '创建波次',
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(139)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/outstorage_action/wave_picking/edite/:id",
                        name: '编辑波次',
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(140)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/outstorage_action/outstock_check",
                        name: '出库复核',
                        component: {
                              template: "<p>outstock_check</p>"
                        }
                  }, {
                        path: "/outstorage_action/purchase_returns",
                        name: '采购退货出库',
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(133)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/outstorage_action/purchase_returns/detail/:id",
                        name: '采购退货出库单详情',
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(132)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }]
            }, {
                  path: '/storage_action',
                  name: '库内作业',
                  component: function component(resolve) {
                        return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(149)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                  },
                  redirect: '/storage_action/warehouse_stock',
                  children: [{
                        path: "/storage_action/warehouse_stock",
                        name: "库位库存",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(151)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/storage_action/inventory_adjustment",
                        name: "库存调整",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(146)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/storage_action/inventory_adjustment/detail/:id",
                        name: "库存调整详情",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(145)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/storage_action/inventory_adjustment/add",
                        name: "新建库存调整",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(35)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/storage_action/inventory_adjustment/edite/:id",
                        name: "编辑库存调整",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(2/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(35)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/storage_action/inventory",
                        name: "盘点",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(144)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/storage_action/inventory/detail/:id",
                        name: "盘点详情",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(142)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/storage_action/inventory/handle_inventory/:id",
                        name: "手工盘点",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(143)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/storage_action/transfer_list",
                        name: "移库记录",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(150)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/storage_action/replenishment_list",
                        name: "补货记录",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(148)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/storage_action/inventory_warning",
                        name: "库存预警",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(147)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }]
            }, {
                  path: '/datachart',
                  name: '数据报表',
                  component: function component(resolve) {
                        return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(106)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                  },
                  redirect: '/datachart/goods_stock',
                  children: [{
                        path: "/datachart/goods_stock",
                        name: "商品库存",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(108)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/datachart/goods_stock/flow/:goodsId",
                        name: "库存流水",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(107)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/datachart/instorage",
                        name: "入库",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(110)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        },
                        redirect: '/datachart/instorage/summary',
                        children: [{
                              path: '/datachart/instorage/summary',
                              name: '入库汇总',
                              component: function component(resolve) {
                                    return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(111)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                              }
                        }, {
                              path: '/datachart/instorage/detailed',
                              name: '入库明细',
                              component: function component(resolve) {
                                    return __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(109)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                              }
                        }]
                  }, {
                        path: "/datachart/outstorage",
                        name: "出库",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(113)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        },
                        redirect: '/datachart/outstorage/summary',
                        children: [{
                              path: '/datachart/outstorage/summary',
                              name: '出库汇总',
                              component: function component(resolve) {
                                    return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(114)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                              }
                        }, {
                              path: '/datachart/outstorage/detailed',
                              name: '出库明细',
                              component: function component(resolve) {
                                    return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(112)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                              }
                        }]
                  }, {
                        path: "/datachart/inventory_profit_loss",
                        name: "盘点损益",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(115)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/datachart/sales_list",
                        name: "销售出库排行",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(116)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }, {
                        path: "/datachart/warehouse_log",
                        name: "仓库日志",
                        component: function component(resolve) {
                              return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(117)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                        }
                  }]
            }, {
                  path: '/sys_setting',
                  name: '系统配置',
                  component: function component(resolve) {
                        return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(152)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
                  },
                  redirect: '/sys_setting/operation_log',
                  children: [{
                        path: "/sys_setting/operation_log",
                        component: {
                              template: "<p>operation_log</p>"
                        }
                  }, {
                        path: "/sys_setting/reservoir_dictionary",
                        component: {
                              template: "<p>reservoir_dictionary</p>"
                        }
                  }, {
                        path: "/sys_setting/library_sequence",
                        component: {
                              template: "<p>library_sequence</p>"
                        }
                  }, {
                        path: "/sys_setting/warehouse_staff",
                        component: {
                              template: "<p>warehouse_staff</p>"
                        }
                  }, {
                        path: "/sys_setting/post_manage",
                        component: {
                              template: "<p>post_manage</p>"
                        }
                  }, {
                        path: "/sys_setting/department_manage",
                        component: {
                              template: "<p>department_manage</p>"
                        }
                  }, {
                        path: "/sys_setting/business_rules",
                        component: {
                              template: "<p>business_rules</p>"
                        }
                  }]
            }]
      }]
});

router.beforeEach(function (to, from, next) {
      var path = to.path.split("/");
      __WEBPACK_IMPORTED_MODULE_2_store___default.a.set("path", path);
      next();
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(78)
}
var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(90),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_es6_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_3_es6_promise___default.a.polyfill();

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 78:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[59]);


// WEBPACK FOOTER //
// static/js/app.f1d4708360989d4b13dc.js